import React from 'react';

const FullAccessBanner = () => (
  <div className="full-access-banner">
    <div className="full-access-banner__wrapper">
      <span className="full-access-banner__text">
        Full access includes real-time data, and complete app coverage.
      </span>
      <a
        className="full-access-banner__cta"
        href="https://apptopia.com/en/ai-dashboard-requests"
        target="_blank"
        rel="noopener noreferrer"
      >
        Contact Us
      </a>
    </div>
  </div>
);

export default FullAccessBanner;
